export const PostingCellTypes = {
  Minus: "minus",
  Plus: "plus",
};
export const RowTypes = {
  RowGroup: "rowGroup",
  PlayerAttribute: "playerAttribute",
  Player: "player",
  PlusMinus: "plusMinus",
  Activity: "activity",
  Grid: "grid",
  Letter: "letter",
  NavHeader: "navHeader",
  NavProperty: "navProperty",
  Blank: "blank",
  Sign: "sign",
};

export const ColumnTypes = {
  ColumnGroup: "columnGroup",
  Activity: "activity",
  TrackType: "trackType",
  Player: "player",
  Grid: "grid",
  Number: "number",
  NavHeader: "navHeader",
  NavProperty: "navProperty",
  Flow: "flow",
  Blank: "blank",
};

export const CellTypes = {
  Activity: "activity",
  ColumnGroup: "golumngroup",
  RowGroup: "rowgroup",
  Player: "player",
  Header: "header",
  Content: "content",
  TrackType: "tracktype",
  PlusMinus: "plusminus",
  PlayerAttribute: "playerAttribute",
  Number: "number",
  Letter: "letter",
  NavHeader: "navHeader",
  NavProperty: "navProperty",
  HeaderRightAlign: "headerRightAlign",
  SignIcon: "signIcon",
  HeaderLeftAlign: "leftAlign",
  Grid: "grid",
};
export const defaultThemes = {
  [CellTypes.Activity]: "pink",
  [CellTypes.ColumnGroup]: "pink",
  [CellTypes.TrackType]: "pink",
  [CellTypes.Player]: "lightblue",
  [CellTypes.RowGroup]: "lightblue",
  [CellTypes.Content]: "white",
  [CellTypes.Header]: "gray",
  [CellTypes.PlayerAttribute]: "lightblue",
  [CellTypes.PlusMinus]: "lightblue",
  [CellTypes.Number]: "number",
  [CellTypes.Letter]: "letter",
  [CellTypes.NavHeader]: "blue",
  [CellTypes.NavProperty]: "cornerLightBlue",
  [CellTypes.HeaderRightAlign]: "rightAlign",
  [CellTypes.SignIcon]: "signIcon",
  [CellTypes.HeaderLeftAlign]: "leftAlign",
  [CellTypes.Grid]: "grid",
};
export const defaultStyles = {
  rightAlign: {
    color: "#083277",
    fontSize: "10px",
    bgColor: "#F1F3F7",
    verticalAlign: "center",
    textAlign: "right",
    fontWeight: "bold",
  },
  leftAlign: {
    color: "#083277",
    fontSize: "10px",
    bgColor: "#F1F3F7",
    verticalAlign: "middle",
    textAlign: "left",
    fontWeight: "bold",
  },
  pink: {
    color: "#083277",
    bgColor: "#E1D7C8",
    verticalAlign: "center",
  },
  lightblue: {
    bgColor: "#083277",
    color: "white",
    textAlign: "center",
    verticalAlign: "center",
  },
  cornerLightBlue: {
    bgColor: "#d5e5ff",
    color: "#333",
  },
  white: {
    color: "black",
    bgColor: "white",
  },
  grid: {
    color: "black",
    bgColor: "rgb(250,250,252)",
  },
  gray: {
    color: "#aaa",
    fontSize: "10px",
    bgColor: "#f8f8fb",
    verticalAlign: "bottom",
  },
  blue: {
    color: "rgb(255, 251, 251)",
    bgColor: " rgb(114, 165, 226)",
  },
  signIcon: {
    bgColor: "#083277",
  },
};
